import React from "react";
import TableMain from "../Common/table/TableMain";
import { getLastPage } from "../../utils/getLastPage";
import { useTranslation } from "react-i18next";
import RepurchaseTableFilter from "../Common/table/RepurchaseTableFilter";
import { ApiHook } from "../../hooks/apiHook";
import { toast } from 'react-toastify'
import { useQueryClient } from "@tanstack/react-query";


const RepurchaseTable = (props) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const headers = [
    "invoice_no",
    "totalAmount",
    "paymentMethod",
    "purchaseDate",
    'paymentStatus',
    "refundStatus",
    "action"
  ];
  const reportHeaders = [
    t("invoice_no"),
    t("totalAmount"),
    t("paymentMethod"),
    t("purchaseDate"),
    t('status'),
    t('')
  ];
  const refund = ApiHook.CallrefundRequest()
  const lastPage = getLastPage(props.itemsPerPage, props?.data?.totalCount);
  const refundHandler = async (orderDetails) => {
    const data = {
      type: 'order',
      orderId: orderDetails?.id,
      paymentMethods: JSON.stringify([{ "payment_method": orderDetails?.paymentMethodId, "amount": orderDetails?.totalAmount,"name":orderDetails?.paymentMethod }]),
      status: 0,
      totalAmount:orderDetails?.totalAmount
    }
    
    const response = await refund.mutateAsync(data)
    if (response.status) {
      queryClient.invalidateQueries({
        queryKey: ["repurchase-report", props.currentPage, props.itemsPerPage,props?.sortOptions?.sortBy,props?.sortOptions?.direction],
    });
      toast.success(t('refund_request_added'))
    } else {
      toast.error(t(response.description))
    }

  }
  return (
    <div className="ewallet_table_section">
      <div className="ewallet_table_section_cnt">
        <RepurchaseTableFilter headers={headers} data={props.data?.data} type={props.type} reportHeaders={reportHeaders} />
        <div className="table-responsive min-hieght-table">
          <TableMain
            headers={headers}
            data={props.data?.data}
            startPage={1}
            currentPage={props.currentPage}
            totalPages={lastPage}
            type={props.type}
            itemsPerPage={props.itemsPerPage}
            setItemsPerPage={props.setItemsPerPage}
            setCurrentPage={props.setCurrentPage}
            setEpinSortOptions={props.setSortOptions}
            refundHandler={refundHandler}
          />
        </div>
      </div>
    </div>
  );
};

export default RepurchaseTable;
